import Button from 'components/Button'
import { Form, FormActions, FormGroup, FormRow } from 'components/inputs'
import Help from 'components/inputs/Help'
import NumericInput from 'components/inputs/NumericInput'
import { useActivation } from 'hooks/mobx-hooks'
import {
  PRO_SPECIALTY_VALUES,
  SOFTWARE_VALUES,
  STATE_VALUES,
  SUPPLEMENTAL_SOFTWARE_VALUES,
} from 'iam/wellKnownProviderValues'
import { observer } from 'mobx-react'
import React from 'react'
import ProDetailsViewModel from './ProDetailsViewModel'
import { MultiStringSelect, SingleStringSelect } from './StringSelect'

interface ProDetailsProps {
  vm: ProDetailsViewModel
  showActions?: boolean
}

export default observer(function ProDetails({
  vm,
  showActions = true,
}: ProDetailsProps) {
  useActivation(vm)
  const disabled = !vm.editable
  return (
    <Form onSubmit={vm.save}>
      <FormRow>
        <FormGroup label="Software Owned">
          <MultiStringSelect
            value={vm.softwareOwned}
            options={SOFTWARE_VALUES}
            onChange={vm.setSoftwareOwned}
            placeholder="Select software"
            disabled={disabled}
            dataTest="pro-details-software-owned"
          />
        </FormGroup>
      </FormRow>
      <FormRow>
        <FormGroup label="Software Experience">
          <MultiStringSelect
            value={vm.softwareExperience}
            options={SOFTWARE_VALUES}
            onChange={vm.setSoftwareExperience}
            placeholder="Select software"
            disabled={disabled}
            dataTest="pro-details-software-experience"
          />
        </FormGroup>
      </FormRow>
      <FormRow>
        <FormGroup label="Supplemental Software">
          <MultiStringSelect
            value={vm.supplementalSoftware}
            options={SUPPLEMENTAL_SOFTWARE_VALUES}
            onChange={vm.setSupplementalSoftware}
            placeholder="Select software"
            disabled={disabled}
            dataTest="pro-details-supplemental-software"
          />
        </FormGroup>
      </FormRow>
      <FormRow>
        <FormGroup label="Pro Specialties">
          <MultiStringSelect
            value={vm.specialties}
            options={PRO_SPECIALTY_VALUES}
            onChange={vm.setSpecialties}
            placeholder="Select specialties"
            disabled={disabled}
            dataTest="pro-details-specialties"
          />
        </FormGroup>
      </FormRow>
      <FormRow>
        <FormGroup label="Location">
          <SingleStringSelect
            value={vm.stateRegion}
            options={STATE_VALUES}
            onChange={vm.setStateRegion}
            placeholder="Select a state"
            disabled={disabled}
            dataTest="pro-details-location"
          />
        </FormGroup>
      </FormRow>
      <FormRow>
        <FormGroup label="Years of Experience">
          <NumericInput
            min={0}
            step={1}
            precision={0}
            value={vm.yearsExperience}
            disabled={disabled}
            onChange={vm.setYearsExperience}
          />
          <Help error={vm.validation.getError('yearsExperience')} />
        </FormGroup>
      </FormRow>
      {vm.editable && showActions && (
        <FormActions>
          <Button
            submit
            type="primary"
            loading={vm.save.pending}
            disabled={!vm.canSave}
          >
            Save
          </Button>
        </FormActions>
      )}
    </Form>
  )
})
